const { getCookie, setCookie } = require("../common");
const UserModel = require("./userModel");

class UserController {
  static getFingerPrint() {
    return new Promise((res, rej) => {
      const tagKey = "amzTag";
      const cookieTag = getCookie(tagKey);
      const tag = cookieTag || localStorage.getItem(tagKey);
      log(tag, "Finger Cookie is:");
      if (!tag) {
        new UserModel().requestFingerPrint()
          .then((res) => {
            if (res.status === 200) {
              return res.text();
            } else {
              throw new Error(res.status);
            }
          })
          .then((key) => {
            localStorage.setItem(tagKey, key.toString());
            res(key);
          })
          .catch((err) => {
            log(err, "UserController Fetch Error:");
            rej(err);
          });
      } else {
        !cookieTag && setCookie(tagKey, tag, 365, true);
        res(tag);
      }
    });
  }
}

module.exports = UserController;
